module.exports = __webpack_public_path__ + "media/images/common/takumen_ogp-19ccd1b3c2b89acb9775b007a9fa280c.png";